import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Mission from "@/components/sections/Mission";
import Products from "@/components/sections/Products";
import Wholesale from "@/components/sections/Wholesale";
import Testimonials from "@/components/sections/Testimonials";
import Contact from "@/components/sections/Contact";

const Home = () => {
    return (
        <div data-testid="home-page" className="bg-[#0B0E14] text-white">
            <Header />
            <main>
                <Hero />
                <Mission />
                <Products />
                <Wholesale />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
        </div>
    );
};

export default Home;
